export default __webpack_public_path__ + "static/media/check.cd7cfc89.svg";